import axiosInstance, { errorHandler } from "./api";

// AccountRecoveryResource.accountRecoveryRequests
/**
 * Fetch list of all key recovery requests
 */
const fetchRecoveryRequestsList = axios => (
  page,
  size,
  filter,
  sort = "date,desc",
) =>
  axios
    .get("/tps/api/recovery/account-recovery-request", {
      params: { page, size, filter, sort },
    })
    .then(({ data }) => ({
      data: data.data.content,
      total: data.data.totalElements,
    }))
    .catch(errorHandler);

// AccountRecoveryResource.accountRecoveryClose
/**
 * Send request to cancel key recovery request when transaction is not yet created
 */
const revokeById = axios => (id, reason) =>
  axios
    .put(
      "/tps/api/recovery/account-recovery-close",
      { text: reason },
      {
        params: { id },
      },
    )
    .then(({ data }) => data)
    .catch(errorHandler);

// AccountRecoveryResource.accountRecoveryRevoke
/**
 * Send request to cancel key recovery request when transaction is created
 */
const revokeByTx = axios => (trxHash, reason) =>
  axios
    .put(
      "/tps/api/recovery/account-recovery-revoke",
      { text: reason },
      {
        params: { trxHash },
      },
    )
    .then(({ data }) => data)
    .catch(errorHandler);

// AccountRecoveryResource.prepareAccountRecoveryRequest
const prepareAccountRecoveryRequest = axios => ({ accountId, name }) =>
  axios
    .post("/tps/api/recovery/prepare-account-recovery-request", {
      accountId,
      name,
    })
    .then(({ data }) => data.data)
    .catch(errorHandler);

// AccountRecoveryResource.verifyAccountRecoveryRequest
const verifyAccountRecoveryRequest = axios => ({ accountId, code }) =>
  axios
    .post("/tps/api/recovery/verify-account-recovery-request", {
      accountId,
      code,
    })
    .then(({ data }) => data.data)
    .catch(errorHandler);

// AccountRecoveryResource.accountRecoveryRequest
const createAccountRecoveryRequest = axios => ({
  accountId,
  name,
  application,
  documentId,
}) =>
  axios
    .post("/tps/api/recovery/account-recovery-request", {
      accountId,
      name,
      application,
      documentId,
    })
    .then(({ data }) => data.data)
    .catch(errorHandler);

// AccountRecoveryResource.requests
const getRecoveryRequestsList = axios => (
  page,
  size,
  filter,
  sort = "date,desc",
  status,
) =>
  axios
    .post(
      "/tps/api/recovery/requests",
      {
        status,
        filter,
      },
      {
        params: { page, size, sort },
      },
    )
    .then(({ data }) => ({
      data: data.content,
      total: data.totalElements,
    }))
    .catch(errorHandler);

// AccountRecoveryResource.authorize
const approveRecoveryRequest = axios => id =>
  axios
    .put(`/tps/api/recovery/authorize?requestId=${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// AccountRecoveryResource.reject
const rejectRecoveryRequest = axios => id =>
  axios
    .put(`/tps/api/recovery/reject?requestId=${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

const getRecoveryRequestsInfo = axios => (id, isAdmin) =>
  axios
    .get(
      `/tps/api/recovery/${
        isAdmin ? "account-recovery-request" : "requests"
      }/${id}`,
    )
    .then(({ data }) => (isAdmin ? data.data : data))
    .catch(errorHandler);

export default {
  fetchRecoveryRequestsList: fetchRecoveryRequestsList(axiosInstance),
  revokeById: revokeById(axiosInstance),
  revokeByTx: revokeByTx(axiosInstance),
  prepareAccountRecoveryRequest: prepareAccountRecoveryRequest(axiosInstance),
  verifyAccountRecoveryRequest: verifyAccountRecoveryRequest(axiosInstance),
  createAccountRecoveryRequest: createAccountRecoveryRequest(axiosInstance),
  getRecoveryRequestsInfo: getRecoveryRequestsInfo(axiosInstance),
  getRecoveryRequestsList: getRecoveryRequestsList(axiosInstance),
  approveRecoveryRequest: approveRecoveryRequest(axiosInstance),
  rejectRecoveryRequest: rejectRecoveryRequest(axiosInstance),
};
